let groupFilters = {
    props: {
        groupeFiltres: Object
    },
    components: {
        filters
    },
    directives: {
        clickaway
    },
    data() {
        return {
            isDropdownActive: false,
        }
    },
    methods: {
        clickGroupeFiltres() {
            this.isDropdownActive = !this.isDropdownActive;
            // console.log('label:'+this.isDropdownActive)
        },
        clickChildrenLabel() {
            this.isDropdownActive = false;
            // console.log('away:'+this.isDropdownActive)
        }
    },
    // methods: {
    //     filtrevent () {
    //         this.$emit('filtrevent')
    //     }
    // },
    template: `
    <div class="profile cd-filter-block" :class="{ 'is-active': isDropdownActive }" v-clickaway="clickChildrenLabel">
        <h4 @click="clickGroupeFiltres" :rel="groupeFiltres.idGroupe" :class="groupeFiltres.active ? 'selected' : ''">{{ groupeFiltres.alias }}</h4>
        <ul class="cd-filter-content cd-filters list">
            <template v-for="(filtre, index) in groupeFiltres.listeFiltre">
                <filters :filtre="filtre" :groupe-filtres="groupeFiltres" @changed="clickChildrenLabel"></filters> 
            </template>
        </ul>
    </div>
    `
};